import React, { useState } from 'react';

import { PayoutRecentTransactions } from '../';
import { TwoFactorAuth } from '../2fa';
import { AddBeneficiaries } from './add-beneficiaries';
import { ConfirmPayout } from './confirm-payout';
import { ProcessPayout } from './process-payout';

const BulkTransferPage = () => {
  const [currentStage, setCurrentStage] = useState('ADD_BENEFICIARIES');
  const [transactionInfo, setTransactionInfo] = useState(null);

  const CurrentPayoutView = stages[currentStage];

  return (
    <section className="payout">
      <CurrentPayoutView
        transactionInfo={transactionInfo}
        setTransactionInfo={setTransactionInfo}
        setCurrentStage={setCurrentStage}
      />
      <PayoutRecentTransactions />
    </section>
  );
};
const stages = {
  ADD_BENEFICIARIES: AddBeneficiaries,
  CONFIRM_PAYOUT: ConfirmPayout,
  TWOFA_AUTHENTICATION: TwoFactorAuth,
  PROCESS_PAYOUT: ProcessPayout
};

export { BulkTransferPage };
